import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/iupac-regex/pages/CalculatorPage";

export const Route = createFileRoute("/iupac-to-regex")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/iupac-to-regex",
      title: m.iupac_meta_title(),
      description: m.iupac_meta_description(),
      toolName: m.iupac_tool_name(),
      faqs: [
        { q: m.iupac_faq_q1(), a: m.iupac_faq_a1() },
        { q: m.iupac_faq_q2(), a: m.iupac_faq_a2() },
        { q: m.iupac_faq_q3(), a: m.iupac_faq_a3() },
        { q: m.iupac_faq_q4(), a: m.iupac_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
